export default __webpack_public_path__ + "static/OggText-ExtraboldItalic-b8944e6456999e99d5cd32d612db7ee0.ttf";